import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=af73641e"
import script from "./Agenda.vue?vue&type=script&lang=js"
export * from "./Agenda.vue?vue&type=script&lang=js"
import style0 from "./Agenda.vue?vue&type=style&index=0&id=af73641e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports